export default __webpack_public_path__ + "static/media/bulus.d80c0c10.jpeg";